import React from "react";
import { AppState, RedirectLoginOptions } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

import LoginComponent from "../layout/LoginComponent";
import PrivacyPolicy from "../PrivacyPolicy";

const ProtectedComponent = ({
  children,
  isAuthenticated,
  loginWithRedirect,
}: {
  children: JSX.Element;
  isAuthenticated: boolean;
  loginWithRedirect: (options?: RedirectLoginOptions<AppState> | undefined) => Promise<void>;
}): JSX.Element => {
  const { pathname: pathName } = useLocation();

  return (
    <React.Fragment>
      {pathName === "/window/privacy-policy" ? (
        <PrivacyPolicy />
      ) : isAuthenticated ? (
        children
      ) : (
        <LoginComponent loginWithRedirect={loginWithRedirect} />
      )}
    </React.Fragment>
  );
};

export default ProtectedComponent;
